import { NgModule } from '@angular/core';
import { GridTextHighlightPipe } from './gridTextHighlight.filter';
import { SafeHtmlFilter } from './safeHTML.filter';
import { SafeResourceURLPipe } from './safeHTML.filter';

import { CommonModule } from '@angular/common';
import { TextHighlightPipe } from './TextHighlight.filter';
import { CustomDateFormatPipe } from './custom-date-format.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TextHighlightPipe, GridTextHighlightPipe, SafeHtmlFilter, CustomDateFormatPipe, SafeResourceURLPipe],
  exports: [GridTextHighlightPipe, SafeHtmlFilter, TextHighlightPipe, CustomDateFormatPipe, SafeResourceURLPipe],
})
export class SharedPipesModule {}
